<div class="not-found-container">
  <h1>404</h1>
  <p>{{ 'CORE.NOT_FOUND.TITLE' | translate }}</p>
  <p>{{ 'CORE.NOT_FOUND.SUBTITLE' | translate }}</p>
  <a routerLink="/" class="go-home-link">{{ 'CORE.NOT_FOUND.BTN' | translate }}</a>
</div>
